shadow$provide[273] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Mask:{enumerable:true, get:function() {
  return Mask;
}}});
var UGLSL = require("../../../util/glsl.js");
var require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js = require("../base/parent.js");
class Mask extends require$_DOT__DOT__SLASH_base_SLASH_parent_DOT_js.Parent {
  static initClass() {
    this.traits = ["node", "include", "mask", "bind"];
  }
  make() {
    return this._helpers.bind.make([{to:"include.shader", trait:"shader", optional:true},]);
  }
  unmake() {
    return this._helpers.bind.unmake();
  }
  change(changed, touched, _init) {
    if (touched["include"]) {
      return this.rebuild();
    }
  }
  mask(shader) {
    let left, s;
    if (this.bind.shader != null) {
      if (shader) {
        s = this._shaders.shader();
        s.pipe(UGLSL.identity("vec4"));
        s.fan();
        s.pipe(shader);
        s.next();
        s.pipe(this.bind.shader.shaderBind());
        s.end();
        s.pipe("float combine(float a, float b) { return min(a, b); }");
      } else {
        s = this._shaders.shader();
        s.pipe(this.bind.shader.shaderBind());
      }
    } else {
      s = shader;
    }
    return (left = __guard__(this._inherit("mask"), x => x.mask(s))) != null ? left : s;
  }
}
Mask.initClass();
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};